import React from 'react';

const FactureAttente = () => {
    return (
        <div>
            <h1>Facture Attente</h1>
        </div>
    );
};

export default FactureAttente;
